module.exports = __webpack_public_path__ + "static/media/composto.4f0a2294.png";